// Wrappers para /api/vocabulary/*.

import { apiFetch } from './api';

export interface VocabularyItem {
  id: number;
  word: string;
  translation: string | null;
  pronunciation: string | null;
  image_url: string | null;
  level_id: number | null;
  level_slug: string | null;
  level_label: string | null;
  license_slug: string | null;
  is_active: number;
  created_at: string;
  updated_at: string;
}

export async function getWordOfTheDay(): Promise<VocabularyItem | null> {
  const r = await apiFetch<{ status: 'ok'; item: VocabularyItem | null }>('/vocabulary/word-of-the-day');
  return r.item;
}

interface ListFilters {
  level_id?: number;
  license_slug?: string;
  search?: string;
  include_inactive?: boolean;
  limit?: number;
  offset?: number;
}

function toQS(f: ListFilters): string {
  const u = new URLSearchParams();
  if (f.level_id) u.set('level_id', String(f.level_id));
  if (f.license_slug) u.set('license_slug', f.license_slug);
  if (f.search && f.search.trim()) u.set('search', f.search.trim());
  if (f.include_inactive !== undefined) u.set('include_inactive', String(f.include_inactive));
  if (f.limit) u.set('limit', String(f.limit));
  if (f.offset) u.set('offset', String(f.offset));
  const qs = u.toString();
  return qs ? `?${qs}` : '';
}

export async function adminListVocabulary(filters: ListFilters = {}): Promise<{ items: VocabularyItem[]; total: number }> {
  const r = await apiFetch<{ status: 'ok'; items: VocabularyItem[]; total: number }>(`/vocabulary${toQS(filters)}`);
  return { items: r.items, total: r.total };
}

export async function adminGetVocabulary(id: number): Promise<VocabularyItem> {
  const r = await apiFetch<{ status: 'ok'; item: VocabularyItem }>(`/vocabulary/${id}`);
  return r.item;
}

export interface VocabularyInput {
  word: string;
  translation?: string | null;
  pronunciation?: string | null;
  image_url?: string | null;
  level_id?: number | null;
  license_slug?: string | null;
  is_active?: boolean;
}

export async function adminCreateVocabulary(input: VocabularyInput): Promise<{ id: number }> {
  return apiFetch<{ status: 'ok'; id: number }>('/vocabulary', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function adminUpdateVocabulary(id: number, patch: Partial<VocabularyInput>): Promise<void> {
  await apiFetch(`/vocabulary/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
}

export async function adminDeleteVocabulary(id: number): Promise<void> {
  await apiFetch(`/vocabulary/${id}`, { method: 'DELETE' });
}
